import React from 'react';
import Storage from 'react-native-storage';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { CookiesProvider } from 'react-cookie';
import App from './App';
import 'react-responsive-ui/style.css';
import 'react-phone-number-input/style.css';
import '../scss/style.scss';

const storage = new Storage({
    size: 1000,
    storageBackend: window.localStorage,
    defaultExpires: 1000 * 3600 * 24,
    enableCache: true,
    sync: {
    },
});

window.storage = storage;
global.storage = storage;

ReactDOM.render(
    <Router>
        <CookiesProvider>
            <App />
        </CookiesProvider>
    </Router>,
    document.getElementById('root'),
);
